import { DownChevronIcon, Item, ListWrapper } from 'pages/portfolio/styled'
import { IntervalSelectionContainer, IntervalSelectionStyled, SelectedItemWrapper } from './style'

import React from 'react'
import { useClickOutsideComponents } from 'hooks'
import { Text, Weight } from 'components/typography'
import { PortfolioPageProps } from '../../../pages/portfolio/interface'
import { StateConfig, ChartIntervalSet } from '../config'

export const IntervalSelection: React.FC<PortfolioPageProps> = ({ portfolioStorage }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const { dispatch, timeWindow } = portfolioStorage
  const [selectedRange, setSelectedRange] = React.useState<StateConfig>(timeWindow)
  const toggleOpen = () => setIsOpen(!isOpen)

  const { getReference } = useClickOutsideComponents(() => {
    setIsOpen(false)
  })

  const dropdownReference = getReference()

  React.useEffect(() => {
    if (selectedRange) {
      setIsOpen(false)
      dispatch({ type: 'set_current_time_window', payload: selectedRange })
    }
  }, [selectedRange])

  const maybeShowList = () => {
    if (isOpen) {
      return (
        <ListWrapper>
          {ChartIntervalSet.map((item) => (
            <Item key={item.name} onClick={() => setSelectedRange(item)}>
              {item.name}
            </Item>
          ))}
        </ListWrapper>
      )
    }
    return null
  }

  return (
    <IntervalSelectionStyled ref={dropdownReference} onClick={toggleOpen}>
      <IntervalSelectionContainer>
        <SelectedItemWrapper>
          <Text type="small" weight={Weight.Bold}>
            {selectedRange.name}
          </Text>
          <DownChevronIcon open={isOpen} />
        </SelectedItemWrapper>
        {maybeShowList()}
      </IntervalSelectionContainer>
    </IntervalSelectionStyled>
  )
}
